import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { PremiumTestimonials } from './ui/premium-testimonials';
import { animateWithGsap } from '../utils/animations';
import { useState, useEffect } from 'react';
import api from '@/lib/api';
import { hightlightsSlides } from "../constants";

const Highlights = () => {
  const [content, setContent] = useState({
    title: 'Get the highlights.',
    items: [], // Initialize as empty array
  });

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const { data } = await api.get('/sections/Highlights');
        if (data && data.content) {
          const contentMap = {};
          data.content.forEach(item => contentMap[item.key] = item.value);
          if (contentMap.title) setContent(prev => ({ ...prev, title: contentMap.title }));
          if (contentMap.items) {
            try {
              setContent(prev => ({ ...prev, items: JSON.parse(contentMap.items) }));
            } catch (e) { console.error(e); }
          }
        }
      } catch (error) {
        console.error("Failed to fetch highlights content", error);
      }
    };
    fetchContent();
  }, []);

  useGSAP(() => {
    gsap.to('#title', { opacity: 1, y: 0 })
    gsap.to('.link', { opacity: 1, y: 0, duration: 1, stagger: 0.25 })
  }, [])

  return (
    <section id="highlights" className="w-screen overflow-hidden h-full common-padding bg-slate-50 dark:bg-black transition-colors duration-500">
      <div className="screen-max-width">
        <div className="mb-12 w-full md:flex items-end justify-between">
          <h1 id="title" className="section-heading">{content.title}</h1>


        </div>

        <PremiumTestimonials />
      </div>
    </section>
  )
}

export default Highlights